/**
 * Navbar
 */
import $ from 'jquery';

import 'bootstrap/js/dist/collapse';

// Custom
import 'protons';

// Module template
import './_navbar.twig';

// Import custom sass, includes Bootstrap sass
import './_navbar.scss';

export const name = 'navbar';

const isMobile = () => $(window).width() < 992;
const debounce =
  window.Drupal && window.Drupal.debounce ? window.Drupal.debounce : fn => fn();
const t = window.Drupal && window.Drupal.t ? window.Drupal.t : str => str;

export function disable() { }

export function enable($context) {
  $($context)
    .find('.navbar')
    .each(function eachNavbarElFn() {
      const $this = $(this);
      const isOpen = () => $this.attr('aria-expanded') === 'true';
      const $toggler = $this.find('.navbar__toggler');
      const $submenus = $this.find('.subnavbar__submenu');
      const $submenuInner = $this.find('.navbar__submenu-content__inner');
      const hide = () => {
        $this.attr('aria-expanded', 'false');
        $toggler.removeClass('btn-black active').addClass('btn-primary');
        $('body').removeClass('has-visible-mobile-menu');
        // reset
        // eslint-disable-next-line no-use-before-define
        showSubmenu();
      };
      const $buttonCasino = $this.find('.navbar__online-casino-link').parent();
      const $buttonRoyal = $this.find('.navbar__royal-club-link').parent();
      $buttonCasino.clone().appendTo('.navbar__submenu-content__inner');
      $buttonRoyal.clone().appendTo('.navbar__submenu-content__inner');
      const $socialIcons = $this.find('.subnavbar .social-icons a');
      const $social = $this.find('.subnavbar .social-icons');
      const show = () => {
        $this.attr('aria-expanded', 'true');
        $toggler.removeClass('btn-primary').addClass('btn-black active');
        $('body').addClass('has-visible-mobile-menu');
      };
      let menuHistory = [];
      if (!$submenus.hasClass('active')) {
        //$('.subnavbar .social-icons').remove();
      }
      if ($socialIcons.length === 0) {
        $('.subnavbar .social-icons').remove();
      }
      // Mobile behavior
      const showSubmenu = id => {
        $submenus.removeClass('active');
        $submenuInner.removeClass('active');
        $social.removeClass('active');
        $submenus.find('.subnavbar__back-button-region').remove();
        if (id) {
          $this.find('.navbar__main-menu-content').hide();
          const $activeSubmenu = $submenus.filter(
            (i, el) => el.id === `"${id}"`
          );
          // Prevent duplicates
          if (
            menuHistory.length === 0 ||
            menuHistory[menuHistory.length - 1] !== id
          ) {
            menuHistory.push(id);
          }
          // eslint-disable-next-line no-use-before-define
          $activeSubmenu.prepend(makeBackButton());

          $activeSubmenu.addClass('active');
          $submenuInner.addClass('active');
          $social.addClass('active');
          $activeSubmenu.className += ' otherclass';
        } else {
          menuHistory = [];
          $this.find('.navbar__main-menu-content').show();
          $social.removeClass('active');
        }
      };
      const makeBackButton = () => {
        const $wrapper = $(
          '<div class="subnavbar__back-button-region w-100 bg-white" />'
        );
        const $btn = $(
          `<button class="btn btn-link text-left text-size-large w-100 subnavbar__back-button d-flex align-items-center">
            <span class="ion ion-ios-arrow-back text-size-huge mr-2"></span>
            <span>${t('Alle Standorte')}</span>
          </button>`
        );
        $btn.click(() => showSubmenu(menuHistory[menuHistory.length - 2]));
        return $wrapper.append($btn);
      };
      let mobileInitialised = false;
      // Initialise mobile behavior
      const initMobile = () => {
        if (mobileInitialised) {
          return;
        }
        mobileInitialised = true;
        $this.find('.navbar__menu-content .nav-link.active');
        const $active = $this
          .find('.navbar__menu-content .nav-link.active')
          .attr('data-nav-submenu-target');
        showSubmenu($active);
        // .click(function mobileMainNavLinkClickFn(e) {
        // e.preventDefault();
        // const submenuTarget = $(this).attr('data-nav-submenu-target');
        // showSubmenu(submenuTarget);
        // });
      };
      // Destroy the mobile behaviors
      const destroyMobile = () => {
        if (!mobileInitialised) {
          return;
        }
        mobileInitialised = false;
      };
      const checkIfShouldInitMobile = () =>
        isMobile() ? initMobile() : destroyMobile();

      // Update state on click
      $toggler.click(() => (isOpen() ? hide() : show()));

      // Set the correct state initially
      setImmediate(() => {
        if (isMobile()) {
          if (!isOpen()) {
            hide();
          } else {
            show();
          }
          initMobile();
        }
      });

      $(window).on('resize', debounce(checkIfShouldInitMobile));
    });
}

export default enable;


// This is automatically added by drupal-behaviors-loader
Drupal.behaviors[name] = {
  attach: enable,
  detach: disable,
};